import { Component, OnInit, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskUtility } from '../../../utility/mask-utility';
import { MaskConfig } from '../../../utility/mask-config';
import { Observable } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { UserInputOptionType } from 'projects/bis-shared/src/lib/shared-models/user-input-option-type';
import { FormsModule } from '@angular/forms';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';


@Component({
  selector: 'app-third-party-administrator-external-lookup-form',
  templateUrl: './third-party-administrator-external-lookup-form.component.html',
  styleUrls: ['./third-party-administrator-external-lookup-form.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, GenericInputComponent, SelectInputComponent],

     
})
export class ThirdPartyAdministratorExternalLookupFormComponent
  extends GenericLookupForm
  implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);

  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  @Input() events: Observable<void>;
  formLoaded = false;
  AppUrls = AppUrls;
  feinMaskConfig: MaskConfig;
  tpaNumberMaskConfig: MaskConfig;
  inIdMaskConfig = MaskUtility.getEntityIdMask('TP');

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService
      .getFormGroupForModel('thirdPartyAdministratorExternalLookup')
      .subscribe(formInfo => {
        this.formInfo = formInfo;
        this.form = formInfo.formGroup;
        this.markFormGroupTouched(this.form);
        this.formLoaded = true;
      });
  }

  search() {
    this.enterKey.emit();
  }

  onFeinChange() {
    this.feinMaskConfig = MaskUtility.getExternalFEINMask();
  }

  onTpaNumberChange() {
    this.tpaNumberMaskConfig = MaskUtility.getTpaNumberMask();
  }

  public isValid(): boolean {
    return this.form && this.form.valid;
  }

  public reset(): void {
    this.form.reset({
      nameSearchOptionType: UserInputOptionType.Contains,
    });
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: UntypedFormGroup) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
